import { Link } from 'react-router-dom';
import { business } from '../data/business';
import './LegalPage.css';

function TermsPage() {
  return (
    <main className="legal-page">
      <div className="legal-page__inner">
        <p className="legal-page__eyebrow">Terms</p>
        <h1>이용약관</h1>
        <p className="legal-page__lead">
          본 약관은 {business.name}이 제공하는 {business.productName}(i-LOG) 관련 웹사이트 및
          문의 서비스 이용에 관한 조건을 규정합니다.
        </p>

        <section>
          <h2>제1조 (목적)</h2>
          <p>
            본 약관은 회사가 제공하는 서비스의 이용 조건과 절차, 회사와 이용자의 권리·의무 및
            책임사항을 규정함을 목적으로 합니다.
          </p>
        </section>

        <section>
          <h2>제2조 (정의)</h2>
          <ul>
            <li>&quot;회사&quot;란 {business.name}을 말합니다.</li>
            <li>
              &quot;서비스&quot;란 {business.productName} 부스 소개, 도입 문의, 관련 안내 콘텐츠를
              포함한 웹 서비스를 말합니다.
            </li>
            <li>&quot;이용자&quot;란 본 약관에 따라 서비스를 이용하는 자를 말합니다.</li>
          </ul>
        </section>

        <section>
          <h2>제3조 (약관의 게시와 개정)</h2>
          <p>
            회사는 본 약관을 서비스 화면에 게시합니다. 관련 법령을 위배하지 않는 범위에서 약관을
            개정할 수 있으며, 개정 시 적용일자와 사유를 공지합니다.
          </p>
        </section>

        <section>
          <h2>제4조 (서비스의 제공)</h2>
          <ul>
            <li>아이로그 서비스 및 부스 소개</li>
            <li>도입 문의 접수 및 상담 안내</li>
            <li>기타 회사가 정하는 부가 서비스</li>
          </ul>
        </section>

        <section>
          <h2>제5조 (이용자의 의무)</h2>
          <p>
            이용자는 허위 정보를 기재하거나 타인의 정보를 도용해서는 안 되며, 서비스의 정상적
            운영을 방해하는 행위를 해서는 안 됩니다.
          </p>
        </section>

        <section>
          <h2>제6조 (문의 정보의 처리)</h2>
          <p>
            도입 문의 시 제출한 정보는 상담 목적 범위에서 사용되며, 개인정보 처리에 관한 사항은
            개인정보처리방침 및 개인정보 수집·이용 동의 내용을 따릅니다.
          </p>
        </section>

        <section>
          <h2>제7조 (면책)</h2>
          <p>
            회사는 천재지변, 불가항력, 이용자의 귀책사유로 발생한 서비스 이용 장애에 대해 책임을
            지지 않습니다. 웹사이트에 게시된 정보는 안내 목적이며, 개별 계약 조건은 별도 협의에
            따릅니다.
          </p>
        </section>

        <section>
          <h2>제8조 (준거법 및 관할)</h2>
          <p>
            본 약관은 대한민국 법령에 따라 해석되며, 분쟁 발생 시 회사 소재지 관할 법원을 제1심
            관할 법원으로 합니다.
          </p>
        </section>

        <section>
          <h2>부칙</h2>
          <p>본 약관은 게시일부터 시행합니다.</p>
          <ul>
            <li>상호: {business.name}</li>
            <li>대표: {business.representative}</li>
            <li>사업자등록번호: {business.registrationNumber}</li>
            <li>주소: {business.address}</li>
          </ul>
        </section>

        <Link to="/" className="legal-page__back">
          ← 랜딩으로 돌아가기
        </Link>
      </div>
    </main>
  );
}

export default TermsPage;
